module.exports = __webpack_public_path__ + "img/baac.2412cdfe.jpg";